import styled, { DefaultTheme } from 'styled-components';
import { defaultStyles, Styles } from 'react-modal';
import { ContentWrapper as ContentWrapperStyled } from '../AccountMenu/AccountMenu.styles';
import { Text } from '../Text/Text';

export const modalStyles = (theme: DefaultTheme): Styles => ({
  overlay: {
    ...defaultStyles.overlay,
    backgroundColor: `${theme.colors.backgroundAccentGreyStrongerGrey80}bf`,
    zIndex: 1001,
  },
  content: {
    ...defaultStyles.content,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'end',
    inset: 0,
    border: 'none',
    background: 'none',
    overflow: 'hidden',
    padding: 0,
    width: '100%',
    height: '100%',
    borderRadius: 0,
  },
});

export const Name = styled(Text)`
  font-size: 20px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.textPrimarySecondary1100};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    font-size: 24px;
  }
`;

export const HeaderActions = styled.div`
  display: flex;
  justify-content: space-between;
  margin-left: 4px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.small}) {
    margin: 0 6px 0 10px;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.small}) {
    button {
      height: 24px;
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    margin: 0 29px 0 33px;
  }
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: end;
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
`;

export const ContentWrapper = styled(ContentWrapperStyled)`
  padding: 16px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.small}) {
    padding-left: 26px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    padding-left: 48px;
  }
`;

export default {};
